module.exports = __webpack_public_path__ + "static/media/imgHacker.f3703630.svg";